import React, { FC, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Badge from "./Badge";
import Button from "shared/Button/Button";
import Badge3 from "./Badge3";


const ReservationCard = ({
	data,
	buttonSw=true
}: any) => {
	console.log("data>> ", data);
	// const getTripDuration = (
	// 	start: string,
	// 	end:string
	// ) => {
	// 	const startDate = new Date(start);
	// 	const endDate = new Date(end);
	  
	// 	// 밀리초 단위로 차이 계산
	// 	const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
		
	// 	// 일 수 차이 계산
	// 	const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	  
	// 	// 시간 차이 계산 (분 단위로 반올림)
	// 	const diffHours = Math.round((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  
	// 	if (diffDays === 0 && diffHours < 24) {
	// 	  return "무박 1일";
	// 	} else if (diffDays === 1 || (diffDays === 0 && diffHours >= 24)) {
	// 	  return "1박 2일";
	// 	} else {
	// 	  return `${diffDays}박 ${diffDays + 1}일`;
	// 	}
	// };

	const getTripDuration = (
		_reservationStart: string,
		_reservationEnd:string
	  ) => {
		const startDate = new Date(_reservationStart);
		const endDate = new Date(_reservationEnd);

		console.log(_reservationStart)
		console.log(_reservationEnd)

		// Check for special case: both dates are 2023-12-31
		if (startDate.toISOString().startsWith('2023-12-31') && 
			endDate.toISOString().startsWith('2023-12-31')) {
		  return "상시일정";
		}
	  
		// 밀리초 단위로 차이 계산
		const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
		
		// 일 수 차이 계산
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	  
		// 시간 차이 계산 (분 단위로 반올림)
		const diffHours = Math.round((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	  
		if (diffDays === 0 && diffHours < 24) {
		  return "무박 1일";
		} else if (diffDays === 1 || (diffDays === 0 && diffHours >= 24)) {
		  return "1박 2일";
		} else {
		  return `${diffDays}박 ${diffDays + 1}일`;
		}
	  };

	//console.log('rrr', data)

	useEffect(() => {

		// if ((reserveCount+reserveAgency) >= minGuests) {
		// 	setCardStatus("확정");
		// } else {
		// 	setCardStatus("대기");
		// }
	}, []);

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			year: year,
			month: month,
			day: day,
		};
	};

	console.log("sss>>sss ", data);
	
	if (Object.keys(data).length === 0) return (<></>);

	const _reservationSchedule = getTripDuration(data.product_travelStart, data.product_travelEnd);
	const travelStart: any = formatKoreanDate(data.product_travelStart);
	const travelEnd: any = formatKoreanDate(data.product_travelEnd);
	const travelEndText: any = `${travelEnd.month}-${travelEnd.day}`;
	
	let statusLabel: any = '모집중';

	// if ((data.product_reserveCount + data.product_reserveAgency) >= data.product_minGuests) {
	// 	statusLabel = '확정';
	// }

	//{data.product_minGuests}

	if (Object.keys(data).length === 0) return (<></>)

		return (

		<div
			className={`group bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl overflow-hidden shadow-xl transition-shadow mt-5`}
		>
			{/* <Link to={`/reservation/${data.no}`} className="absolute inset-0"></Link> */}

			<div className="w-full flex">
				<div className="flex-shrink-0 p-3 w-[8rem]">
					<div className={`block aspect-w-1 aspect-h-1`}>

						{data.product_cover.type === "video"
						?
							<video 
								className="object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"
								loop 
								muted
								autoPlay
								playsInline  // Safari에서 인라인 재생을 강제
								controls={false}  // 컨트롤 숨김
								disablePictureInPicture  // PiP 모드 비활성화
								webkit-playsinline="true"  // iOS Safari 지원
								src={`${process.env.REACT_APP_SERVER_FILE}/products/${data.product_no}/${data.product_cover.src}`}
							/>
						:
							<img
								src={`${process.env.REACT_APP_SERVER_FILE}/products/${data.product_no}/${data.product_cover.src}`}
								className={"object-cover w-full h-full rounded-2xl overflow-hidden will-change-transform"}
							/>
						}
					</div>
				</div>

				
				<div className="flex-grow p-3 sm:pr-6 flex flex-col items-start">
					<div className="space-y-2 w-full">
						<div>
							<div className="flex items-center space-x-2">
								<Badge3
									label={statusLabel}
									color={statusLabel==="확정" ? "green" : "red"}	
								/>
								<h2 className="capitalize">
									<span 
										className="line-clamp-2 text-[0.95rem]" 
										style={{fontWeight: "600", color:"#282f33"}}
									>
										{data.product_title}
									</span>
								</h2>
							</div>
						</div>
						<div className="flex-row sm:flex items-center sm:justify-between">
							<div className="text-[0.95rem] space-x-1" style={{fontWeight: "500", color:"#586066"}}>
								
								<span className="tracking-tighter">
									{travelStart.date}
								</span>
								<span className="">
									~
								</span>
								<span className="tracking-tighter">
									{travelEndText}
								</span>
							</div>
							<span className="text-[0.95rem]" style={{fontWeight: "500", color:"#586066"}}>
								{_reservationSchedule}
							</span>
						</div>	
						
						

						<div className="flex w-full justify-between">

							<div className="flex">
								{/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.0" stroke="currentColor" className="size-6">
									<path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
								</svg> */}
								<span className="ml-[3px] text-[0.9rem]"  style={{fontWeight: "500", color:"#586066"}}>
									{data.product_minGuests}명 예약
								</span>
								
							</div>

							<span className="text-[0.95rem]"  style={{fontWeight: "600", color:"#282f33"}}>
								{data.product_price.toLocaleString('ko-KR')}원
							</span>
						</div>

						<div className="w-full">
							{data.product_priceOptions.map((item: any) => {
								if (item.amount === 0) {
									return (<></>);
								} else {
									return (
										<div>
											<span className="flex block mt-2 text-neutral-500 dark:text-neutral-400">
												<div className="w-full">
													{item.label} ({item.amount}명)
												</div>
												<div>
													
												</div>
												<div className="text-right w-[120px]">
													{(item.price * item.amount).toLocaleString('ko-KR')}원
												</div>
											</span>
										</div>
									);
								}
							})}
						</div>


					</div>
				</div>
			</div>

			{buttonSw && (
				<div className="w-full p-3">
					<Link to={`/reservation/${data._id}`}>
						{/* <Button
							className={`w-full ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 m-3`}
						>
							예약자 정보 변경
						</Button> */}
						<button
							className="w-full text-neutral-50 bg-primary-6000 hover:bg-primary-700 focus:outline-none focus:ring-0 h-10 rounded-full hover:bg-neutral-100"
						>
							예약자 정보 변경
						</button>
					</Link>
				</div>
			)}
		</div>

	);
};

export default ReservationCard;